import { NgIf } from '@angular/common';
import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ThemeModeService } from '@portal-core/general/services/theme-mode.service';

/**
 * mc-theme-mode-toggle
 * A navbar button that switches the portal between the light and dark themes.
 * Renders nothing in apps that have not opted into dark mode with DARK_MODE_ENABLED.
 */
@Component({
  selector: 'mc-theme-mode-toggle',
  templateUrl: './theme-mode-toggle.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, MatIconButton, MatIcon, MatTooltip]
})
export class ThemeModeToggleComponent {
  protected readonly themeModeService = inject(ThemeModeService);

  /** The button's tooltip and accessible label, naming the theme a click switches to. */
  protected readonly label = computed(() => this.themeModeService.isDark() ? 'Switch to light mode' : 'Switch to dark mode');

  /** The icon for the theme a click switches to. */
  protected readonly fontIcon = computed(() => this.themeModeService.isDark() ? 'icon-sun' : 'icon-moon');
}
